import { UTM_PARAMS } from '@dupe/common/constants'
import { useRouter } from 'next/router'

const useCaptureUTMParams = () => {
  const router = useRouter()
  const queryParams = router.query

  const utmParams = UTM_PARAMS.reduce<Record<string, string>>((acc, param) => {
    if (queryParams[param]) {
      acc[param] = queryParams[param] as string
    }
    return acc
  }, {})

  return utmParams
}

export default useCaptureUTMParams
